import { TValidationRules } from "../../../../interface/FormGenerator"

const validateRegex = (value: any, validationRules: TValidationRules) => {
  for (const rule of validationRules) {
    if (!rule.regex.test(value)) {
      return rule.message
    }
  }
  return true
}

export { validateRegex }
